export function isAdmin() {
      if(typeof wp !== 'undefined') return true;
      return false;
    }

export function isLoggedInAdmin() {
      if(!isAdmin()) return false;
      if(!wp.hasOwnProperty('userSettings')) return false;
      if(wp.userSettings.uid > 0) return true;
      return false
    }

export function editorDatas(){
      if(isLoggedInAdmin()) return wp.data.select('core/editor');
      return false;
    }

export function currentPostId() {
      let postId = false;
      
      if(exists(acseoPlugin)) {
        if(exists(acseoPlugin.postId)) return onlyNumbers(acseoPlugin.postId);
      } 

      let datas = false;
      if(datas = editorDatas()) return onlyNumbers(datas.getCurrentPostId());
      
      document.body.classList.forEach(className=>{
          if(className.includes('page-id-')) postId = className.split('-')[2];
          if(postId) return onlyNumbers(postId);
      });

      return false;
    }

export function exists(el) {
      if(el === undefined || el === null) return false;
      if(el.length === 0) return false;
      return true;
    }

export function toggleClass(el,className) {
      if(!exists(el)) return false;
      if(el.classList.contains(className)) {
        el.classList.remove(className);
        return false;
      } else {  
        el.classList.add(className);
        return true;
      }
    }

export function toggleClasses(el,class1,class2) {

      if(!exists(el)) return false;
      if(el.classList.contains(class1)) {
        el.classList.add(class2);
        el.classList.remove(class1);
        return;
      } 
      if(el.classList.contains(class2)) {  
        el.classList.remove(class2);
        el.classList.add(class1);
        return;
      }
    }

export function toggleSiblings(el, siblings, className = acseoPlugin.activeCssClass) {
      if(!exists(el)) return;
      if(!exists(siblings)) return;
      siblings.forEach(sibling => {
          if(sibling != el) sibling.classList.remove(className);
      });

      toggleClass(el,className);
    }

export function createElement(tag, id = false, className = false) {
      let el = document.createElement(tag);
      if(id) el.id = id;
      if(className) el.classList.add(className);
      return el;
    }


export function moveToBody(el, prepend = false) {
      if (document.querySelector(`body #${el.id}`)) return;
      if (prepend) {
        document.body.prepend(el);
        return;
      }
      document.body.appendChild(el);
    }

export function wrap(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    }

export function fetchAjax(action, jsonDatas, nonce, callBack, that = null, beforeSend = false, complete = false, loadingHandler = () => {} ) {
      const fetchDatas = new FormData();
      fetchDatas.append( 'action', action );
      fetchDatas.append( 'nonce', nonce );
      fetchDatas.append( 'datas', jsonDatas );

      const requestOptions = {
          method: 'POST',
          body: fetchDatas
      };

      const datas = JSON.parse(jsonDatas);
      beforeSend && beforeSend(that, datas);
      
      fetch(acseoPlugin.url, requestOptions)
        .then(response => {
            if (!response.ok) {
                console.error(response);
                throw new Error(response.text());
            }
            return response.text();
        })
        .then(responseText => {
            callBack && callBack(responseText, datas, that); 
        })
        .catch(error => {
            console.error("Fetch error:", error);
        })
        .finally(() => {
            complete && complete(that, datas);
            loadingHandler();
      });

    }

export function onlyNumbers(e){//i.e.: clean html from counter or price elements
    return parseInt(e.replace(/[^0-9]/g,""));
  }

export function arraySearch(value, array) {
    for(var key in array) { 
      if(typeof(array[key]) == 'object') {
        if(array[key].includes(value)) return true;
      }
      if(typeof(array[key]) == 'string') {
        if(array[key] == value) return true;
      }
    }
    return false;
  }

export function copyToClipboard(selector = 'button.copy, .button.copy') {

      let buttons = document.querySelectorAll(selector);

      if(!exists(buttons)) return;
      
      buttons.forEach(button => {
          button.addEventListener('click',function(e){
            e.preventDefault();
            e.stopPropagation();
            
            if(!this.dataset.value) return;
            
            let content = this.dataset.value;
            let parent = this.parentElement;
            let copyTextarea = document.createElement("textarea");
            copyTextarea.style.position = "fixed";
            copyTextarea.style.opacity = "0";
            copyTextarea.textContent = content;
        
            document.body.appendChild(copyTextarea);
            copyTextarea.select();
            document.execCommand("copy");//No replacement for this command
            parent.classList.add(acseoPlugin.activeCssClass);
            setTimeout(function(){
              parent.classList.remove(acseoPlugin.activeCssClass);
            },1000);
            document.body.removeChild(copyTextarea);
        });
      });
      
    }

export function cssComputedProperty(el, prop, compare = null) {
    if (!el) return false;
    const computedStyle = window.getComputedStyle(el);
    const propertyValue = computedStyle.getPropertyValue(prop);
    if (compare === null) return propertyValue;
    return propertyValue === compare;
  }

export function appendNodeList(parentEl, nodeList) {
    if (!exists(nodeList) || !exists(parentEl)) return;
    nodeList.forEach(function (node) {
        parentEl.appendChild(node);
    });  
  }

/**
 * 
 * @param accordions "NodeList"
 * @param triggerSelector "string"
 * @param panelSelector "string"
 * @param reset "boolean"
 * @returns void
 */
export function setAccordionClasses({//accordion-js does not work properly with custom selectors
      accordions = null,
      triggerSelector = null,
      panelSelector = null,
      reset = false,
    }) {

    if(!exists(accordions) || triggerSelector == null || panelSelector == null) return;
    
    accordions.forEach(el => {//accordion-js does not work properly with custom selectors
    
        if(cssComputedProperty(el, 'display') == 'none') return;
        
        let trigger = el.querySelector(triggerSelector);
        let panel = el.querySelector(panelSelector);
        if(!exists(trigger) || !exists(panel)) return;

        if(!el.classList.contains('ac')) el.classList.add('ac');
        if(!trigger.classList.contains('ac-trigger')) trigger.classList.add('ac-trigger');
        if(!panel.classList.contains('ac-panel')) panel.classList.add('ac-panel');

        if(reset) {
          el.classList.remove('ac');
          trigger.classList.remove('ac-trigger');
          panel.classList.remove('ac-panel');
        }
    
    });
  }

/**
 * 
 * @param el "HTMLElement"
 * @param viewportOrigin "%" | "100" | "0"
 * @param elOrigin "center" | "top" | "bottom"
 * @param tolerance "px"
 * @returns boolean
 */
export function isElementInViewport(el, viewportOrigin = 100, elOrigin = 'center', tolerance = 0) {
    if(!exists(el)) return false;

    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    viewportOrigin = viewportOrigin === 0 ? 0 : windowHeight * (viewportOrigin / 100);

    if(elOrigin === 'center') elOrigin = (rect.top + rect.bottom) / 2;
    if(elOrigin === 'top') elOrigin = rect.top;
    if(elOrigin === 'bottom') elOrigin = rect.bottom;

    if(Math.abs(elOrigin) < (windowHeight - viewportOrigin + tolerance)) return true;
    return false;
  }